import isEmpty from 'lodash/isEmpty';

import { Product, Team } from 'teams';
import noop from 'utils/noop';
import { ActionName } from 'services/observability/types';
import { datadogReporter } from 'services/observability/reporters';
import { createErrorMonitor } from 'services/observability/utilities';

import { VocabularyResponse } from './types';
import { isVocabularyEmpty } from './goalUtils';

const { runWithReporting } = datadogReporter;

export const createActionName = (name: string): ActionName => ({
  name,
  teamName: Team.AI_TEAM,
  productName: Product.ITERABLE_GOALS,
});

export const monitorVocab = runWithReporting<[VocabularyResponse | undefined], void>(
  createActionName('Vocabulary loading'),
  noop,
  (vocab: VocabularyResponse | undefined) => {
    if (isVocabularyEmpty(vocab)) {
      throw new Error('Vocabulary is missing or not ready');
    }
    if (isEmpty(vocab?.predictiveAudiencesVocabulary)) {
      throw new Error('Vocabulary loaded with empty object');
    }
  },
  { errorsOnly: true },
);

export const reportGoalEditError = createErrorMonitor(createActionName('Error during goal edit'));
export const reportGoalCreationError = createErrorMonitor(
  createActionName('Error during goal creation'),
);
export const reportGoalDeleteError = createErrorMonitor(
  createActionName('Error during goal deletion'),
);
